export const eSignChinaUnite = {
  "chooseSignTypeDialog": {
    "title": "",
    "slogan": "",
    "personTypeName": "",
    "orgTypeName": "",
    "cancelBtn": ""
  },
  "outSignManageDialog": {
    "title": "",
    "refreshBtn": ""
  },
  "gallery": {
    "personESignTokenTimeOut": "",
    "orgESignTokenTimeOut": "",
    "authorizeBtn": "",
    "cancelAuthorizeBtn": "",
    "outSignUserExpireMsg1": "",
    "outSignUserExpireMsg2": "",
    "fetchOutGalleryDataErrorMsg1": "",
    "fetchOutGalleryDataErrorMsg2": "",
    "fetchUserInfoError": "",
    "fetchInGalleryDataErrorMsg1": "",
    "fetchInGalleryDataErrorMsg2": ""
  },
  "outStampManageDialog": {
    "fetchOutStampListErrorTooltip1": "",
    "fetchOutStampListErrorTooltip2": "",
    "personAdminBtn": "",
    "orgAdminBtn": "",
    "noOutStampList": "",
    "fetchOutStampListErrorMsg1": "",
    "fetchOutStampListErrorMsg2": ""
  },
  "auth": {
    "noOutSignPermission": "",
    "subscriptionExpire": "",
    "contactSales": "",
    "ok": "",
    "checkOutSignSubscription": ""
  },
  "bindPhoneDialog": {
    "cancelMsg": "",
    "cancelMsg2": "",
    "ok": "",
    "cancel": "",
    "bindErrorPhone": "",
    "sign": "",
    "title": ""
  },
  "status0Display": {
    "title": "",
    "msg1": "",
    "msg2": ""
  },
  "status1Display": {
    "title1": "",
    "title2": ""
  },
  "status2Display": {
    "title": "",
    "msg1": ""
  },
  "auditTrail": {
    "headerTitle": "",
    "noData": "",
    "title0": "",
    "title1": "",
    "title2": "",
    "title3": "",
    "title4": "",
    "conclusion": {
      "issuer": {
        "atLeast1Invalid": "",
        "atLeast1NotVerified": "",
        "atLeast1UnKnow": "",
        "atLeast1NotRevokes": "",
        "allValid": "",
        "verifiedError": ""
      },
      "willingness": {
        "atLeast1UnKnow": "",
        "allValid": ""
      },
      "fileModifiedStatus": {
        "isModifiedForAuditTrail": "",
        "isModifiedWithAllowedForAuditTrail": "",
        "notModified": "",
        "verifiedError": ""
      },
      "sign": {
        "atLeast1Invalid": "",
        "allValid": "",
        "atLeast1UnKnow": "",
        "verifiedError": "",
        "error": ""
      },
      "illegalSignBehavior": {
        "existIllegalSignBehavior": "",
        "notExistIllegalSignBehavior": ""
      },
      "declaration": {
        "title": "",
        "tip1": "",
        "tip2": ""
      }
    },
    "baseInfo": {
      "pageCounts": "",
      "hash": "",
      "signStartTime": "",
      "signEndTime": "",
      "prefix": "",
      "byteRangeHash": "",
      "signedHash": ""
    },
    "issuerAuthInfo": {
      "issuerIndex": "",
      "out": {
        "conjunction1": "",
        "conjunction2": "",
        "conjunction3": ""
      },
      "in": {
        "conjunction1": "",
        "conjunction2": "",
        "conjunction3": "",
        "conjunction4": "",
        "conjunction5": "",
        "conjunction6": "",
        "conjunction7": ""
      }
    },
    "certFileInfo": {
      "title": "",
      "subject": "",
      "serialNumber": "",
      "issuer": "",
      "format": "",
      "validDate": "",
      "conjunction": ""
    },
    "signProcess": {
      "conjunction1": "",
      "conjunction2": "",
      "conjunction3": "",
      "conjunction4": "",
      "initFlowSign": "",
      "flowSign": "",
      "illegalSignBehavior": ""
    }
  },
  "survey": {
    "msg": "",
    "btn": ""
  },
  "applyStamp": {
    "title": "",
    "slogan": "",
    "dialogOkBtn": "",
    "dialogCancelBtn": "",
    "applyConfirmMsg": "",
    "isApplying": "",
    "applySuccessMsg": "",
    "applyFailMsg": "",
    "resendConfirmMsg": "",
    "isResending": "",
    "resendSuccessMsg": "",
    "resendFailMsg": "",
    "refreshBtn": "",
    "networkError": "",
    "hasAllOrgStampPermission": ""
  },
  "guide": {
    "ESignChinaTitle": "",
    "ESignChinaDescribe": ""
  },
  "signRecord": {
    "copySuccessTips": ""
  }
}